// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 404 Page Styles */
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
}

.not-found-content {
  max-width: 600px;
}

.error-code {
  font-size: 8rem;
  font-weight: 800;
  color: var(--color-primary);
  line-height: 1;
  margin-bottom: 1rem;
}

.error-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--color-text);
}

.error-description {
  font-size: 1.125rem;
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: var(--color-primary);
  color: white;
  border: 2px solid var(--color-primary);
}

.btn-primary:hover {
  background-color: var(--color-primary-dark);
  border-color: var(--color-primary-dark);
  color: #f59e0b;
}

.btn-outline {
  background-color: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}

.btn-outline:hover {
  background-color: var(--color-primary);
  color: white;
}

@media (max-width: 768px) {
  .error-code {
    font-size: 6rem;
  }
  
  .error-title {
    font-size: 1.5rem;
  }
  
  .error-actions {
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/404/404.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["/* 404 Page Styles */\r\n.not-found-page {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.not-found-content {\r\n  max-width: 600px;\r\n}\r\n\r\n.error-code {\r\n  font-size: 8rem;\r\n  font-weight: 800;\r\n  color: var(--color-primary);\r\n  line-height: 1;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.error-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1rem;\r\n  color: var(--color-text);\r\n}\r\n\r\n.error-description {\r\n  font-size: 1.125rem;\r\n  color: var(--color-text-secondary);\r\n  margin-bottom: 2rem;\r\n  line-height: 1.6;\r\n}\r\n\r\n.error-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn {\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 0.5rem;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n  border: 2px solid var(--color-primary);\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: var(--color-primary-dark);\r\n  border-color: var(--color-primary-dark);\r\n  color: #f59e0b;\r\n}\r\n\r\n.btn-outline {\r\n  background-color: transparent;\r\n  color: var(--color-primary);\r\n  border: 2px solid var(--color-primary);\r\n}\r\n\r\n.btn-outline:hover {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .error-code {\r\n    font-size: 6rem;\r\n  }\r\n  \r\n  .error-title {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .error-actions {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
